import NewsPage from '@/pages/content/news/list/NewsPage.vue'
import EditNewsPage from '@/pages/content/news/edit/EditNewsPage.vue'
import FAQPage from '@/pages/content/faq/list/FAQPage.vue'
import EditQuestionPage from '@/pages/content/faq/edit/EditQuestionPage.vue'
// slides
import DefaultLayout from '@/layouts/DefaultLayout.vue'

export default [
  {
    name: 'content',
    path: '/content',
    redirect: { name: 'slides-list' },
    component: DefaultLayout,
    children: [
      {
        name: 'news',
        path: 'news',
        meta: {
          title: 'Новости - Школа Летово',
        },
        redirect: { name: 'news-list' },
        component: DefaultLayout,
        children: [
          {
            name: 'news-list',
            path: 'news-list',
            component: NewsPage,
            meta: {
              title: 'Новости - Школа Летово',
            },
          },
          {
            name: 'create-news',
            path: 'create-news',
            component: EditNewsPage,
            meta: {
              title: 'Создание новости - Школа Летово',
            },
          },
          {
            name: 'edit-news',
            path: 'create-news/:id',
            component: EditNewsPage,
            meta: {
              title: 'Редактирование новости - Школа Летово',
            },
          },
        ],
      },
      {
        name: 'faq',
        path: 'faq',
        meta: {
          title: 'FAQ - Школа Летово',
        },
        redirect: { name: 'faq-list' },
        component: DefaultLayout,
        children: [
          {
            name: 'faq-list',
            path: 'faq-list',
            component: FAQPage,
            meta: {
              title: 'FAQ - Школа Летово',
            },
          },
          {
            name: 'create-question',
            path: 'create-question',
            component: EditQuestionPage,
            meta: {
              title: 'Создание вопроса - Школа Летово',
            },
          },
          {
            name: 'edit-question',
            path: 'create-question/:id',
            component: EditQuestionPage,
            meta: {
              title: 'Редактирование вопроса - Школа Летово',
            },
          },
        ],
      },
    ],
  },
]
